module.exports = __webpack_public_path__ + "static/media/wolffox4.21090b1f.jpg";